<template>
    <transition  >
    <div class="container-fluid ">
        <div class="row">
                <div class="col-12">
                    <div class="page-title-box">
                        <div class="page-title-right float-left">
                            <ol class="breadcrumb m-0"> 
                                <li class="breadcrumb-item active">Diagnosis Billing </li>
                                <li class="breadcrumb-item"><a href="javascript: void(0);">Sample Collection Process</a></li>
                                
                            </ol>
                        </div>
                    </div>
                </div>
            </div>  
            <div class="row">
                <div class="col-12">
                    <!-- Search and export area -->
                    <div class="card">
                        <div class="card-header">
                            <div class="row">      
                                <div class="col-md-3"></div>                  
                                <div class="col-md-6">
                                    <div class="mb-1">
                                        <div class="form-group autocomplete">
                                            <input
                                                type="text"
                                                v-model="searchTerm"
                                                class="form-control"
                                                placeholder="Scan/Search Test Invoice"
                                                @keyup.enter="fetchDiagnosisBillingInvoice()" 
                                                
                                            />
                                            <div class="invalid-feedback" v-if="errors.searchTerm">
                                                {{errors.searchTerm[0]}}
                                            </div>
                                            <ul
                                                v-if="searchTests.length"
                                                class="w-full rounded bg-white border border-gray-300 px-4 py-2 space-y-1 absolute z-10 autocomplete-results"
                                            >
                                                <li>
                                                    Showing {{ searchTests.length }} of {{ test_items.length }} results
                                                </li>
                                                <li
                                                v-for="(item, i) in searchTests.slice(0, 15)"
                                                :key="item.name"
                                                @change="selectTests(item)"
                                                @click="setResult(item)"
                                                class="cursor-pointer hover:bg-gray-100 p-1"
                                                :class="{ 'is-active': i === arrowCounter }"
                                                >
                                                {{ item.name }}
                                                </li>
                                            </ul>
                                        </div>
                                    </div>    
                                </div>
                                <div class="col-md-3"></div>
                            </div>
                        </div>

                        <div class="card-body">   
                            <form v-if="!loading">
                                <!-- Bill Information -->
                                <div class="row mb-3">
                                    <div class="col-md-12">
                                        <h4 class="wpr_general_sign_title">Invoice, Patient information and Other's </h4>
                                    </div>

                                    <div class="col-md-12">
                                        <div class="row">
                                            <div class="col-md-6 mb-1">
                                                <div class="row">
                                                    <div class="col-md-4">
                                                        <label for="bill_no" style="width: 100%; height: 34px; padding: 10px;">Invoice No <span style="color: red">*</span></label>
                                                    </div>
                                                    <div class="col-md-8">
                                                        <input type="text" class="form-control border" v-model="form.bill_no" placeholder="Enter Bill No" readonly  @keypress="onkeyPress('bill_no')">
                                                        <div class="invalid-feedback" v-if="errors.bill_no">
                                                            {{errors.bill_no[0]}}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            <div class="col-md-6 mb-1">
                                                <div class="row">
                                                    <div class="col-md-4">
                                                        <label for="bill_date" style="width: 100%; height: 34px; padding: 10px;">Invoice Date  <span style="color: red">*</span></label>
                                                    </div>
                                                    <div class="col-md-8">
                                                        <input type="date" class="form-control border" v-model="form.bill_date" placeholder="Enter Date" readonly @keypress="onkeyPress('bill_date')">
                                                        <div class="invalid-feedback" v-if="errors.bill_date">
                                                            {{errors.bill_date[0]}}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            <div class="col-md-6 mb-1">
                                                <div class="row">
                                                    <div class="col-md-4">
                                                        <label for="patient_name" style="width: 100%; height: 34px; padding: 10px;">Patient Name  <span style="color: red">*</span></label>
                                                    </div>
                                                    <div class="col-md-8">
                                                        <input type="text" class="form-control border" v-model="form.patient_name" placeholder="Enter Patient Name" readonly @keypress="onkeyPress('patient_name')">
                                                        <div class="invalid-feedback" v-if="errors.patient_name">
                                                            {{errors.patient_name[0]}}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            <div class="col-md-6 mb-1">
                                                <div class="row">
                                                    <div class="col-md-4">
                                                        <label for="patient_phone" style="width: 100%; height: 34px; padding: 10px;">Patient Phone <span style="color: red">*</span></label>
                                                    </div>
                                                    <div class="col-md-8">
                                                        <input type="text" class="form-control border" v-model="form.patient_phone" placeholder="Enter Patient Phone" readonly @keypress="onkeyPress('patient_phone')">
                                                        <div class="invalid-feedback" v-if="errors.patient_phone">
                                                            {{errors.patient_phone[0]}}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            <div class="col-md-6 mb-1">
                                                <div class="row">
                                                    <div class="col-md-4">
                                                        <label for="patient_age" style="width: 100%; height: 34px; padding: 10px;">Patient Age <span style="color: red"></span></label>
                                                    </div>
                                                    <div class="col-md-8">
                                                        <input type="text" class="form-control border" v-model="form.patient_age" placeholder="Enter Patient Age" readonly @keypress="onkeyPress('patient_age')">
                                                        <div class="invalid-feedback" v-if="errors.patient_age">
                                                            {{errors.patient_age[0]}}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            <div class="col-md-6 mb-1">
                                                <div class="row">
                                                    <div class="col-md-4">
                                                        <label for="patient_gender" style="width: 100%; height: 34px; padding: 10px;">Gender <span style="color: red"></span></label>
                                                    </div>
                                                    <div class="col-md-8" style="pointer-events: none;">
                                                        <Multiselect 
                                                            class="form-control border" 
                                                            mode="single"
                                                            v-model="form.patient_gender"
                                                            placeholder="Gender"  
                                                            :searchable="true" 
                                                            :filter-results="true"
                                                            :options="gender_options"
                                                            :classes="multiclasses"
                                                            :close-on-select="true" 
                                                            :min-chars="1"
                                                            :resolve-on-load="false" 
                                                            :create-option="false" 
                                                            @change="onkeyPress('patient_gender')"
                                                            v-if="renderOptionComponent"
                                                        />  
                                                        <div class="invalid-feedback" v-if="errors.patient_gender">
                                                            {{errors.patient_gender[0]}}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            <div class="col-md-6 mb-1">
                                                <div class="row">
                                                    <div class="col-md-4">
                                                        <label for="reference_type" style="width: 100%; height: 34px; padding: 10px;">Reference Type <span style="color: red">*</span></label>
                                                    </div>
                                                    <div class="col-md-8" style="pointer-events: none;">
                                                        <Multiselect 
                                                            class="form-control border" 
                                                            mode="single"
                                                            v-model="form.reference_type"
                                                            placeholder="Select Reference Type"  
                                                            :searchable="true" 
                                                            :filter-results="true"
                                                            :options="[{label:'Doctor', value:'doctor'}, {label:'Self', value:'self'}, {label:'Others', value:'others'}]"
                                                            :classes="multiclasses"
                                                            :close-on-select="true" 
                                                            :min-chars="1"
                                                            :resolve-on-load="false" 
                                                            :create-option="false" 
                                                            v-if="renderOptionComponent"
                                                        />                                                   
                                                        <div class="invalid-feedback" v-if="errors.reference_type">
                                                            {{errors.reference_type[0]}}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            <div class="col-md-6 mb-1">
                                                <div class="row">
                                                    <div class="col-md-4">
                                                        <label for="reference_person_id" style="width: 100%; height: 34px; padding: 10px;">Reference Person <span style="color: red">*</span></label>
                                                    </div>
                                                    <div class="col-md-8" style="pointer-events: none;">
                                                        <input type="hidden" class="form-control border" v-model="form.reference_person_name">
                                                        <Multiselect 
                                                            class="form-control border" 
                                                            mode="single"
                                                            v-model="form.reference_person_id"
                                                            placeholder="Select Reference"  
                                                            :searchable="true" 
                                                            :filter-results="true"
                                                            :options="doctor_options"
                                                            :classes="multiclasses"
                                                            :close-on-select="true" 
                                                            :min-chars="1"
                                                            :resolve-on-load="false"
                                                            :create-option="true" 
                                                            @change="changeReferencePerson"
                                                            v-if="renderOptionComponent"
                                                        />                                                   
                                                        <div class="invalid-feedback" v-if="errors.reference_person_id">
                                                            {{errors.reference_person_id[0]}}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            <div class="col-md-6 mb-1">
                                                <div class="row">
                                                    <div class="col-md-4">
                                                        <label for="delivery_date" style="width: 100%; height: 34px; padding: 10px;">Date of Delivery  <span style="color: red">*</span></label>
                                                    </div>
                                                    <div class="col-md-8">
                                                        <input type="date" class="form-control border" v-model="form.delivery_date" readonly @change="changeDeliveryDateTime(), onkeyPress('delivery_date')" placeholder="Enter Date">
                                                        <div class="invalid-feedback" v-if="errors.delivery_date">
                                                            {{errors.delivery_date[0]}}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row" v-if="form.bill_no != ''">
                                            <div class="col-md-12 mb-1" style="text-align: right;">
                                                <button type="button" class="btn btn-primary btn-sm" title="Label Print" style="margin-right: 5px;" @click="singleBarcode(form)">
                                                    <i class="fas fa-print"></i> Label Print
                                                </button>
                                            </div>
                                        </div>

                                        <hr>

                                        <!-- Diagnosis Test Information -->
                                        <div class="item_area" style="padding: 10px; border: 1px solid #e0e0e0;">
                                            <div class="row">
                                                <div class="col-md-12">
                                                    <h4 class="wpr_general_sign_title">Test Items </h4>
                                                </div>
                                            </div>

                                            <div class="row">
                                                <div class="col-md-12">
                                                    <div class="table-responsive" style="padding: 0;">
                                                        <table class="table table-bordered table-centered mb-0">
                                                            <thead>
                                                                <tr>
                                                                    <th width="5%">SL</th>
                                                                    <th width="30%">Test/Service</th>
                                                                    <th width="10%">Qty</th>
                                                                    <th width="10%">Rate</th>
                                                                    <th width="10%">Disc%</th>
                                                                    <th width="10%">Total</th>
                                                                    <th width="15%">Delivery Date/Time</th>
                                                                    <th width="10%">Action</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr v-for="(item, index) in form.ptest_items" :key="index">
                                                                    <td>{{index+1}}</td>
                                                                    <td>{{item.name}}</td>                                                    
                                                                    <td>{{ item.qty }}</td>
                                                                    <td>{{ item.price }}</td>
                                                                    <td>{{ item.discount }}</td>
                                                                    <td class="text-right" v-if="item.discount > 0">{{ (item.price * item.qty) - (((item.price * item.qty) * item.discount) / 100) }}</td>
                                                                    <td class="text-right" v-else>{{ (item.price * item.qty) }}</td>
                                                                    <td class="text-right"><input type="text" class="form-control" v-model="item.delivery_datetime" /></td>
                                                                    <td>
                                                                        <button v-if="item.sample_collected_datetime == ''" type="button" class="btn btn-info btn-sm" title="Sample Collected" @click="setSampleCollection(index, 'not_collected')">
                                                                            <i class="fas fa-check"></i>
                                                                        </button>
                                                                        <button v-else type="button" class="btn btn-danger btn-sm" title="Sample Collected" @click="setSampleCollection(index, 'collected')">
                                                                            <i class="fas fa-stop"></i>
                                                                        </button>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <hr>

                                <!-- Payment and Discount  -->
                                <div class="row mb-3">
                                    <div class="col-md-12" style="border-right: 1px solid #e0e0e0;">
                                        <!-- Reagent Items -->
                                        <!-- <h4 style="padding-bottom: 5px; border-bottom: 1px solid #e0e0e0;">Reagent and Accesories: </h4>
                                        <div class="table-responsive" style="padding: 0;">
                                            <table class="table table-bordered table-centered mb-0">
                                                <thead>
                                                    <tr>
                                                        <th width="5%">SL</th>
                                                        <th width="50%">Reagent/Accesories</th>
                                                        <th width="10%">Qty</th>
                                                        <th width="10%">Rate</th>
                                                        <th width="10%">Total</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(item, index) in form.ptest_reagent_items" :key="index">
                                                        <td>{{index+1}}</td>
                                                        <td>{{item.name}}</td>                                                    
                                                        <td><input type="number" class="form-control" v-model="item.qty"></td>
                                                        <td>{{item.price}}</td>
                                                        <td class="text-right">{{ item.price * item.qty }}</td>
                                                        <td>
                                                            <button type="button" class="btn btn-danger btn-sm" @click="removeTestListItem(index)">
                                                                <i class="fas fa-trash"></i>
                                                            </button>
                                                        </td> -->
                                                    <!--</tr>
                                                </tbody>
                                            </table>
                                        </div> -->

                                        <!-- Stationery Items -->
                                        <h4 style="padding-bottom: 5px; border-bottom: 1px solid #e0e0e0;">Stationery Items: </h4>
                                        <div class="table-responsive" style="padding: 0;">
                                            <table class="table table-bordered table-centered mb-0">
                                                <thead>
                                                    <tr>
                                                        <th width="5%">SL</th>
                                                        <th width="50%">Item</th>
                                                        <th width="10%">Qty</th>
                                                        <th width="10%">Rate</th>
                                                        <th width="10%">Total</th>
                                                        <th width="10%">Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(item, index) in form.ptest_stequipment_items" :key="index">
                                                        <td>{{index+1}}</td>
                                                        <td>
                                                            <Multiselect 
                                                                class="form-control border" 
                                                                mode="single"
                                                                v-model="item.product_id"
                                                                placeholder="Select Item"  
                                                                :searchable="true" 
                                                                :filter-results="true"
                                                                :options="product_options"
                                                                :classes="multiclasses"
                                                                :close-on-select="true" 
                                                                :min-chars="1"
                                                                :resolve-on-load="false" 
                                                                :create-option="false"
                                                                @change="checkExistsStationaryItem(index, $event)"
                                                                v-if="renderOptionComponent"
                                                            />
                                                        </td>                                                    
                                                        <td><input type="number" class="form-control" v-model="item.qty"></td>
                                                        <td>{{item.price}}</td>
                                                        <td class="text-right">{{ item.price * item.qty }}</td>
                                                        <td>
                                                            <button type="button" class="btn btn-danger btn-sm" @click="removeStationaryItem(index)" style="margin-right: 5px;">
                                                                <i class="fas fa-trash"></i>
                                                            </button>
                                                            <button v-if="form.ptest_stequipment_items.length - 1  == index" type="button" class="btn btn-primary btn-sm" @click="addStationaryItem(index)">
                                                                <i class="fas fa-plus"></i>
                                                            </button>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>

                                        <!-- Room Numbers -->
                                        <h4 style="padding-bottom: 5px; border-bottom: 1px solid #e0e0e0;">Room Numbers: </h4>
                                        <div class="room_numbers" style="padding: 0;">
                                            <button type="button" class="btn btn-dark btn-sm" style="margin: 2px;" v-for="(item, index) in form.room_numbers" :key="index"> {{ item }}</button>
                                        </div>
                                    </div>

                                    <!-- <div class="col-md-5"> -->
                                        <!-- Apply Discount -->
                                        <!-- <div class="row">
                                            <div class="col-md-12">
                                                <h4 style="padding-bottom: 5px; border-bottom: 1px solid #e0e0e0;">Apply Discounts (%)</h4>
                                                <ul class="discount_items">
                                                    <li v-for="(item, index) in discount_items" :key="index">
                                                        <div class="form-check">
                                                            <input type="checkbox" class="form-check-input" :id="item.id" v-model="item.is_checked" @input="applyDiscount(index, item)" />
                                                            <label class="form-check-label" :for="item.id">{{ item.name }}</label>
                                                            <div class="discount_fields" v-if="item.is_checked">
                                                                <div class="item_field" v-if="item.name.toLowerCase().includes('corporate')">
                                                                    <input type="text" v-model="item.discount_flat_val" class="form-control" v-if="item.discount_flat_val > 0">
                                                                    <input type="text" v-model="item.discount_percent" class="form-control" @input="changeApplyDiscount(index, item)" v-else>

                                                                    <input type="text" v-model="form.corporate_company_name" class="form-control" placeholder="Company Name">
                                                                    <input type="text" v-model="form.corporate_employee_id" class="form-control" placeholder="Employee ID">
                                                                    <input type="text" v-model="form.corporate_employee_name" class="form-control" placeholder="Employee Name">
                                                                </div>
                                                                <div class="item_field" v-else>
                                                                    <input type="text" v-model="item.discount_flat_val" class="form-control" v-if="item.discount_flat_val > 0">
                                                                    <input type="text" v-model="item.discount_percent" class="form-control" @input="changeApplyDiscount(index, item)" v-else>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </li>
                                                </ul>
                                            </div>
                                        </div> -->

                                        <!-- <hr>

                                        <div class="payment_amount_area">
                                            <table class="table-sm table table-bordered border" style="margin-bottom: 15px">
                                                <thead class="tableFloatingHeaderOriginal">
                                                    <tr class="item-head">
                                                        <th>Total Item</th>
                                                        <th width="40%" style="text-align: right;">{{ Number(form.ptest_items.length).toLocaleString() }}</th>
                                                    </tr>
                                                    <tr class="border item-head">
                                                        <th>Total</th>
                                                        <th style="text-align: right;">
                                                            {{  Number(totalCartValue)
                                                                .toLocaleString(undefined, {
                                                                    minimumFractionDigits: 2,
                                                                    maximumFractionDigits: 2
                                                                }) 
                                                            }}
                                                        </th> 
                                                    </tr>
                                                    <tr class="item-head">
                                                        <th>Discount ( {{ totalDiscountPercent - totalExtraDiscountPercent }} %) </th>
                                                        <th style="text-align: right;">
                                                            {{ Number(totalGeneralDiscount)
                                                                .toLocaleString(undefined, {
                                                                    minimumFractionDigits: 2,
                                                                    maximumFractionDigits: 2
                                                                })
                                                            }}
                                                        </th>
                                                    </tr>
                                                    <tr class="item-head">
                                                        <th>Extra Discount</th>
                                                        <th style="text-align: right;">
                                                            {{ Number(totalExtraDiscount)
                                                                .toLocaleString(undefined, {
                                                                    minimumFractionDigits: 2,
                                                                    maximumFractionDigits: 2
                                                                }) 
                                                            }}
                                                        </th>
                                                    </tr>
                                                    
                                                    <tr class="item-head">
                                                        <th>Payable Amount</th>
                                                        <th style="text-align: right;">
                                                            {{ Number(netAmountCalculate)
                                                                .toLocaleString(undefined, {
                                                                    minimumFractionDigits: 2,
                                                                    maximumFractionDigits: 2
                                                                }) 
                                                            }}
                                                        </th>
                                                    </tr>
                                                    
                                                    <tr class="item-head">
                                                        <th>Received Amount</th>
                                                        <th style="text-align: right;">
                                                            <input type="number" step="any" scrolling="no" v-model="form.received_amount" class="form-control" style="text-align: right;">
                                                        </th>
                                                    </tr>
                        
                                                    <tr class="item-head">
                                                        <th>Due Amount</th>
                                                        <th style="text-align: right;">
                                                            {{ (netAmountCalculate > form.received_amount) 
                                                                ? Number(netAmountCalculate - form.received_amount)
                                                                    .toLocaleString(undefined, {
                                                                        minimumFractionDigits: 2,
                                                                        maximumFractionDigits: 2
                                                                    }) 
                                                                : Number(0)
                                                                    .toLocaleString(undefined, {
                                                                        minimumFractionDigits: 2,
                                                                        maximumFractionDigits: 2
                                                                    }) 
                                                            }}
                                                        </th>
                                                    </tr>
                                                </thead>
                                            </table>

                                        </div> -->
                                    <!-- </div> -->
                                </div>

                                <div class="row">
                                    <div class="col-md-12" style="border-top: 1px solid #e0e0e0;">
                                        <div class="action_btn" style="padding-top: 10px; text-align: right;">
                                            <!-- <button type="button" class="btn btn-sm btn-danger" id="reset" @click="toggleModal()" style="margin-right: 10px;">
                                                RESET
                                            </button>

                                            <button type="button" class="btn btn-sm btn-warning" id="clear-cart-item" @click="clearAllCartItems" style="margin-right: 10px;">
                                                Clear Item
                                            </button>

                                            <button type="button" class="btn btn-sm btn-info" id="invoice-preview" @click="invoicePreviewModal" style="margin-right: 10px;">
                                                Invoice Preview
                                            </button>  -->

                                            <button type="button" class="btn btn-sm btn-primary " :disabled="disabled" @click.prevent="submitForm()">
                                                <span v-show="isSubmit">
                                                    <i class="fas fa-spinner fa-spin" ></i>
                                                </span>{{btn}} 
                                            </button> 
                                        </div>
                                    </div>
                                </div>
                            </form>

                            <div class="tab-pane show active" v-if="loading">
                                <div class="row"> 
                                    <div class="col-md-5">  
                                    </div>
                                    <div class=" col-md-2"> 
                                        <img src="../../../assets/image/loading.gif" alt="Loading..." style="width:130px">
                                    </div>
                                    <div class="col-md-5">  
                                    </div>
                                </div>
                            </div> 
                        </div>
                    </div>
                </div>
            </div> 

            <!-- Test Label Print -->
            <Modal @close="toggleLabelBarcode" :modalActive="modalActiveLabelBarcode">
                <div class="modal-content scrollbar-width-thin product-barcode-modal">
                    <div class="modal-header"> 
                        <h5>Label Barcode </h5>
                        <button @click="toggleLabelBarcode" type="button" class="btn btn-default">X</button>
                    </div> 
                    <div class="modal-body">  
                        <div class="row d-print-none">
                            <div class="col-md-3">    
                                <label class="form-label" for="product_native_name">Model</label> <br>
                                <select class="form-control border" v-model="barcode_symbology" @change="barcodeSetting"> 
                                    <option value=""> Choose barcode symbology</option>
                                    <option v-for="(barcode, index) in barcode_symbology_list" :value="barcode.name" :key="index" 
                                        > {{barcode.name}}
                                        </option>
                                </select>  
                            </div>
                            <div class="col-md-3">    
                                <label class="form-label" for="product_native_name">Colors</label> <br>
                                <select class="form-control border" v-model="color"  @change="barcodeSetting"> 
                                    <!-- <option value="Black"> Black</option> -->
                                    <option v-for="(color, index) in colors" :value="color.value" :key="index" 
                                        > {{color.label}}
                                        </option>
                                </select>  
                            </div> 
                            <div class="col-md-2">  
                                <label class="form-label" for="product_native_name">Barcode Width</label> <br>  
                                <input class="form-control border" type="number" v-model="barcodeWidth" @input="barcodeSetting">  
                            </div>
                            <div class="col-md-2"> 
                                <label class="form-label" for="product_native_name">Barcode Height</label> <br>   
                                <input class="form-control border" type="number" v-model="barcodeHeight" @input="barcodeSetting">  
                            </div> 
                            <div class="col-md-2"  > 
                                <label class="form-label" >Quantity</label> <br>   
                                <input class="form-control border" type="number" v-model="barcodeQty" @input="barcodeSetting">  
                            </div> 
                        </div>

                        <div class="row" id="labelBarcodePrint" v-if="singleBarcodeEnable">
                            <div class="col-md-3 col-sm-3 col-xs-3" v-for="(item, i) in barcodeQty" > 
                                <div style="text-align: center; margin-top: 10px; border: 1px solid #000;">
                                <!-- <span calss="barcodeName"> {{ product.product_name }}</span><br> -->
                                    <BarcodeGenerator
                                        v-if="barcodeReRender" 
                                        :text="form.bill_no"
                                        :fontSize="12"
                                        :value="form.bill_no"
                                        :format="barcode_symbology"
                                        :lineColor="color" 
                                        :height="barcodeHeight"
                                        :width="barcodeWidth"
                                        :elementTag="'img'"
                                    />  
                                </div> 
                            </div>  
                        </div>                     
                    </div>
                    <div class="modal-footer">
                        <button type="submit" class="btn btn-success float-right " @click="printLabelBarcode">Print</button>
                    </div> 
                </div>
            </Modal>

        </div>
    </transition>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import Modal from "../../helper/Modal";
import BarcodeGenerator from "@/components/BarcodeGenerator.vue";
import Datatable from '@/components/Datatable.vue';
import Pagination from '@/components/Pagination.vue';
import { ref, onMounted } from "vue";
import Form from 'vform'
import axios from 'axios';
export default {
    name: 'Appointments',
    components: {
        Modal,
        BarcodeGenerator,
        Datatable,
        Pagination,
    },
    props:{
        language: {
          type: Object,
          default: () => {
            return {
              lengthMenu: null,
              info: null,
              zeroRecords: null, 
              search: null
            }
          },
        },
    },
    data() {
        return {
            loading: true,
            isSubmit: false,
            showModal: false,
            editMode:false,
            disabled: false,
            modalActive:false,   
            modalActiveLabelBarcode:false,       
            errors: {},
            imagePreview: '',
            btn:'SUBMIT',
            renderOptionComponent: true,
            renderBarcodeComponent: true,
            items: [],
            gender_options: [{label:'Male', value:'male'}, {label:'Female', value:'female'}],
            doctors: [],
            doctor_options: [],
            test_items: [],
            discount_items: [],
            products: [],
            product_options: [],
            test_name: '',
            searchTerm: '',
            arrowCounter: -1,
            searchTests: [],     
            billing_info: '',      
            form: new Form({
                id: '',
                bill_no: '',
                bill_date: '',
                patient_name: '',
                patient_age: '',
                patient_gender: '',
                patient_phone: '',
                reference_type: 'doctor',
                reference_person_id: '',
                reference_person_name: '',
                delivery_date: '',
                delivery_time: '05:00 PM',
                ptest_items: [], 
                ptest_reagent_items: [],
                ptest_stequipment_items: [],
                ptest_discount_items: [],
                room_numbers: [],
                corporate_company_name: '',
                corporate_employee_id: '',
                corporate_employee_name: '',
                vat_tax: 0,
                received_amount: 0,
                status: 1,

            }),            
            barcodeWidth:1.2,
            barcodeHeight:30,
            barcodeReRender:true,
            singleBarcodeEnable: false,
            barcode_symbology: 'CODE128',
            colors: [
                {label:'Black', value:'black'},
                {label:'Red', value:'red'},
                {label:'Green', value:'green'},
                {label:'Blue', value:'blue'},
                {label:'Yellow', value:'yellow'},
                {label:'Pink', value:'pink'},
                {label:'Purple', value:'purple'},
                {label:'Orange', value:'orange'},
            ],
            color: 'black',
            barcodeQty: 1,
            barcode_symbology_list:[{name:'CODE128'},{name:'EAN13'}, {name:'UPC'},{name:'CODE39'},{name:'MSI'}, {name:'codabar'},{name:'ITF14'} ],
            multiclasses: { 
                clear: '',
                clearIcon: '', 
            },

        };
    },

    created() { 
        this.fetchDiagnosisSampleProcessData();
    },

    methods: { 
        forceRerender() {
            // Remove my-component from the DOM
            this.renderOptionComponent = false;
            this.renderBarcodeComponent = false;

            this.$nextTick(() => {
                // Add the component back in
                this.renderOptionComponent = true;
                this.renderBarcodeComponent = true;
            });
        },
        toggleModal: function() {
            this.modalActive = !this.modalActive;   
            if(!this.modalActive){
                this.editMode = false;
                this.btn='Create';
            } 
            this.errors = '';
            this.isSubmit = false;
        },
        toggleLabelBarcode: function() {
          this.singleBarcodeEnable = false;
          this.modalActiveLabelBarcode = !this.modalActiveLabelBarcode;
        },

        singleBarcode : function(data){
          this.modalActiveLabelBarcode = !this.modalActiveLabelBarcode;
          this.singleBarcodeEnable = true;
          console.log(data); 
        },
        barcodeSetting: function() {
            this.barcodeReRender = false;
            this.$nextTick(() => {
                this.barcodeReRender = true;
            });
        },

        fetchDiagnosisSampleProcessData() {
            axios.get(this.apiUrl+'/hm/diagnosis_billings/sample-collection-create', this.headerjson)
            .then((res) => {
                let data = res.data.data;
                this.test_items = data.diagnosis_tests;
                this.doctors = data.doctors;
                this.doctor_options = data.doctors.map((item) => {
                    return {label:item.first_name + ' ' + item.last_name, value:item.id}
                });
                this.discount_items = data.discount_items;
                this.products = data.products;
                this.product_options = this.products.map((item) => {
                    return {label:item.product.product_name, value:item.product_id}
                });
            })
            .catch((err) => { 
                this.$toast.error(err.response.data.message);
            }).finally((ress) => {
                this.loading = false;
            });
        },

        fetchDiagnosisBillingInvoice() {
            if(this.searchTerm != '') {
                
                let request = {
                    invoice_no: this.searchTerm,
                };

                let postEvent = axios.post(this.apiUrl+'/hm/diagnosis_billings/invoice-search', request, this.headerjson);
                postEvent.then((res) => {

                    this.form.fill(res.data.data.billing_info);
                    if(!/^\d+$/.test(res.data.data.billing_info.reference_person_id)) {
                        this.doctor_options.push({label: res.data.data.billing_info.reference_person_name, value: res.data.data.billing_info.reference_person_name});
                    }
                    this.forceRerender();
                })
                .catch((err) => { 
                    this.$toast.error(err.response.data.message);
                }).finally((ress) => {
                    this.searchTerm = '';
                });
            }
        },

        inputChanged(event) {

            if (event.code == "ArrowUp" || event.code == "ArrowDown")
                return;
            if (event.code == "Enter")
                return;
            if(this.searchTerm == '') 
                return;

            this.fetchDiagnosisBillingInvoice();

        },

        changeReferencePerson(selectedValue) {
            const selectedOption = this.doctor_options.find(option => option.value === selectedValue);
            const selectedText = selectedOption ? selectedOption.label : null;

            if (selectedText) {
                this.form.reference_person_name = selectedText;
            } else {
                this.form.reference_person_name = selectedValue;
            }
        },

        setSampleCollection(index, status) {
            let datetime_val = new Date().toLocaleDateString('en-US', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
                hour12: false
            }).replace(',', '');

            let curr_datetime = "";
            let msg = "";
            if(status == 'collected') {
                curr_datetime = "";
                msg = "You want to set this sample as not collected?";
            }else{
                curr_datetime = datetime_val;
                msg = "You want to set this sample as collected?";
            }

            this.$swal({
                title: 'Are you sure?',
                text: msg, 
                showCancelButton: true,
                confirmButtonCategory: '#3085d6',
                cancelButtonCategory: '#d33',
                confirmButtonText: 'Confirm!'
            }).then((result) => { 
                if (result.value) { 
                    this.form.ptest_items[index].sample_collected_datetime = curr_datetime;
                    this.$toast.success("Sample collection status updated successfully.");
                }else{
                    // this.$toast.error(`Hey! I'm here`);
                    // this.$toast.warning(`Hey! I'm here`);
                    // this.$toast.info(`Hey! I'm here`)
                }
            });
        },

        addStationaryItem: function(index) {
            this.form.ptest_stequipment_items.push({
                id: '',
                type: 'stationery',
                product_id: '',
                name: '',
                qty: 1,
                price: '',
            });
        },

        removeStationaryItem: function(index) {
            this.$swal({
                title: 'Are you sure?',
                text: "You want to remove this item!", 
                showCancelButton: true,
                confirmButtonCategory: '#3085d6',
                cancelButtonCategory: '#d33',
                confirmButtonText: 'Remove'
            }).then((result) => { 
                if (result.value) {
                    this.form.ptest_stequipment_items.splice(index, 1);
                }else{
                    // this.$toast.error(`Hey! I'm here`);
                    // this.$toast.warning(`Hey! I'm here`);
                    // this.$toast.info(`Hey! I'm here`)
                }
            });
        },

        checkExistsStationaryItem(index, newProductId) {
            const exists = this.form.ptest_stequipment_items.some((item, i) =>
                i !== index && item.product_id === newProductId
            );

            if (exists) {
                this.form.ptest_stequipment_items.splice(index, 1); // Remove the current item
                this.forceRerender();
                this.form.ptest_stequipment_items.push({
                    id: '',
                    type: 'stationery',
                    product_id: '',
                    name: '',
                    qty: 1,
                    price: '',
                });
                this.$toast.error("This item already exists in the list.");
                return;
            }else {
                const selectedProduct = this.products.find(item => item.product_id === newProductId);
                if (selectedProduct) {
                    this.form.ptest_stequipment_items[index].name = selectedProduct.product.product_name;
                    this.form.ptest_stequipment_items[index].price = selectedProduct.product.cost_price;
                } else {
                    this.form.ptest_stequipment_items[index].name = '';
                    this.form.ptest_stequipment_items[index].price = '';
                }
            }
        },

        selectTests(item) { 
            this.test_name = item.name;
            this.searchTerm = item.name;
        }, 

        setResult(item) { 
            this.test_name = item.name;
            this.searchTerm = item.name;
            this.getTestInvoice();
            this.searchTests = [];
        }, 

            // For Check Product List
        checkExistsTest(array_data, test_name){
            let testExists = false;
            array_data.map((item) => {
                if(item.name == test_name) {
                    testExists = true;
                }
            });

            return testExists;
        },

        removeTestListItem(row_id) {
            if (this.form.ptest_items[row_id]) {
                // Get the test item ID that will be removed
                const testItemId = this.form.ptest_items[row_id].id;
                
                // For Reagent Items
                var relatedReagents = this.form.ptest_reagent_items.filter(item => item.test_ids.includes(testItemId));
                relatedReagents.forEach((reagentItem) => {
                    // Calculate the quantity to decrease based on the specific test item's reagent quantity
                    let testItemReagentQty = this.form.ptest_items[row_id].dtconfig_reagents.find(r => r.reagent_id === reagentItem.id)?.qty || 0;

                    if (testItemReagentQty > 0) {
                        // Decrease the qty of the reagent item
                        reagentItem.qty -= testItemReagentQty;
                        reagentItem.test_ids.splice(reagentItem.test_ids.indexOf(testItemId), 1);
                    }

                    // Check if any other test items use this reagent
                    const isReagentUsedByOthers = this.form.ptest_items.some(item => 
                        item.id !== testItemId && 
                        item.dtconfig_reagents.some(r => r.reagent_id === reagentItem.id)
                    );

                    // If no other test items use this reagent and the qty is zero or less, remove it
                    // if (!isReagentUsedByOthers && reagentItem.qty <= 0) {
                    if (!isReagentUsedByOthers) {
                        this.form.ptest_reagent_items.splice(this.form.ptest_reagent_items.indexOf(reagentItem), 1);
                    }
                });

                // For Staionery Items
                var releatedStationery = this.form.ptest_stequipment_items.filter(item => item.test_ids.includes(testItemId));
                releatedStationery.forEach((stationeryItem) => {
                    // Calculate the quantity to decrease based on the specific test item's reagent quantity
                    let testItemStationeryQty = this.form.ptest_items[row_id].dtconfig_stequipments.find(r => r.product_id === stationeryItem.id)?.qty || 0;

                    if (testItemStationeryQty > 0 && stationeryItem.name.toLowerCase() != 'memo') {
                        // Decrease the qty of the reagent item
                        stationeryItem.qty -= testItemStationeryQty;
                        stationeryItem.test_ids.splice(stationeryItem.test_ids.indexOf(testItemId), 1);
                    }

                    // Check if any other test items use this reagent
                    const isStationeryUsedByOthers = this.form.ptest_items.some(item => 
                        item.id !== testItemId && 
                        item.dtconfig_stequipments.some(r => r.product_id === stationeryItem.id)
                    );

                    // If no other test items use this reagent and the qty is zero or less, remove it
                    // if (!isReagentUsedByOthers && reagentItem.qty <= 0) {
                    if (!isStationeryUsedByOthers) {
                        this.form.ptest_stequipment_items.splice(this.form.ptest_stequipment_items.indexOf(stationeryItem), 1);
                    }
                });

                // For Room Numbers 
                const testItemRoom = this.form.ptest_items[row_id].allocated_room;
                const isRoomUsedByOthers = this.form.ptest_items.some(item => 
                    item.id !== testItemId && item.allocated_room === testItemRoom
                );

                // If no other test items use this room, remove it from room_numbers
                if (!isRoomUsedByOthers) {
                    const roomIndex = this.form.room_numbers.indexOf(testItemRoom);
                    if (roomIndex !== -1) {
                        this.form.room_numbers.splice(roomIndex, 1);
                    }
                }

                // Finally, remove the test item from ptest_items
                this.form.ptest_items.splice(row_id, 1);
            } else {
                this.$toast.error("Oop's, something went wrong please try again!");
            }
        },

        onArrowDown: function(event) {
            if (this.searchTests.length > 0) {
                this.arrowCounter = event.code == "ArrowDown" ? ++this.arrowCounter : --this.arrowCounter;
                if (this.arrowCounter >= this.searchTests.length)
                this.arrowCounter = (this.arrowCounter) % this.searchTests.length;
                else if (this.arrowCounter < 0)
                this.arrowCounter = this.searchTests.length + this.arrowCounter;
                this.selectTests(this.searchTests[this.arrowCounter]);
            }
        },

        onArrowUp: function(event) {
            if (this.searchTests.length > 0) {
                this.arrowCounter = event.code == "ArrowUp" ? --this.arrowCounter : ++this.arrowCounter;
                if (this.arrowCounter >= this.searchTests.length)
                this.arrowCounter = (this.arrowCounter) % this.searchTests.length;
                else if (this.arrowCounter < 0)
                this.arrowCounter = this.searchTests.length + this.arrowCounter;
                this.selectTests(this.searchTests[this.arrowCounter]);
            }
        },

        changeDeliveryDateTime() {
            if(this.form.delivery_date != '' && this.form.ptest_items.length > 0) {
                this.form.ptest_items.forEach((pitem) => {
                    return pitem.delivery_datetime = this.form.delivery_date + ' 05:00 PM';
                });
            }
        },

        submitForm: function(e) {  
            this.isSubmit = true;
            this.disabled = true;
            const formData = new FormData();    
            formData.append('id', this.form.id);
            formData.append('bill_no', this.form.bill_no);
            formData.append('ptest_items', JSON.stringify(this.form.ptest_items));
            formData.append('ptest_stequipment_items', JSON.stringify(this.form.ptest_stequipment_items));
            formData.append('status', this.form.status);

            var postEvent = axios.post(this.apiUrl+'/hm/diagnosis_billings/sample-collection_store', formData, this.headers);          

            postEvent.then(res => {
                this.isSubmit = false;
                this.disabled = false;
                if(res.status == 200){
                    console.log(res.data.data);
                    this.$toast.success(res.data.message);
                    this.form.reset();
                }else{
                    this.$toast.error(res.data.message);
                } 
            }).catch(err => { 
                this.isSubmit = false; 
                this.disabled = false;
                this.$toast.error(err.response.data.message);
                if(err.response.status == 422){
                    this.errors = err.response.data.errors 
                } 
            });
        }, 

        validation: function (...fiels){ 
            var obj = new Object(); 
            var validate = false;
            for (var k in fiels){     // Loop through the object  
                for (var j in this.form){  
                    if((j==fiels[k]) && (!this.form[j])) {  
                        obj[fiels[k]] = fiels[k].replace("_", " ")+' field is required';  // Delete obj[key]; 
                        this.errors = {...this.errors, ...obj};
                    }else{
                        validate = false;
                    }
                }              
            }  
            // var obj = new Object();
            // obj[fiels] = fiels.replace("_", " ")+' field is required';  
            // this.errors = {...this.errors, ...obj}; 
        },
        onkeyPress: function(field) { 
            for (var k in this.errors){     // Loop through the object
                if(k==field){      // If the current key contains the string we're looking for 
                    delete this.errors[k];  // Delete obj[key];
                }
            }  
        },
        deleteItem: function(item) {
            this.$swal({
                title: 'Are you sure?',
                text: "You want delete this bill!", 
                showCancelButton: true,
                confirmButtonCategory: '#3085d6',
                cancelButtonCategory: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => { 
                if (result.value) { 
                    axios.delete(this.apiUrl+'/hm/diagnosis_billings/'+item.id,this.headerjson)
                    .then(res => {
                        if(res.status == 200){  
                            this.fetchDiagnosisBIllingCreateData();
                            this.$toast.success(res.data.message); 
                        }else{
                            this.$toast.error(res.data.message);
                        }
                    }).catch(err => {  
                        this.$toast.error(err.response.data.message); 
                    }) 
                }else{
                    // this.$toast.error(`Hey! I'm here`);
                    // this.$toast.warning(`Hey! I'm here`);
                    // this.$toast.info(`Hey! I'm here`)
                }
            }); 
        },

        printLabelBarcode(){
            this.printContent('labelBarcodePrint');
        },

        printContent(document_id, css_url='') { 
            const width = 800;
            const height = 600;
            const left = (screen.width - width) / 2;
            const top = (screen.height - height) / 2;

            const options = {
                name: '_blank',
                specs: [
                    `width=${width}`,
                    `height=${height}`,
                    `top=${top}`,
                    `left=${left}`,
                    'fullscreen=no',
                    'titlebar=yes',
                    'scrollbars=yes'
                ],
                styles: [ 
                    this.baseUrlPrintCSS+'/assets/css/bootstrap-print.min.css',
                    css_url
                ],
            };
            this.$htmlToPaper(document_id, options);
        },


    },
    destroyed() {},
    mounted() {
        window.scrollTo(0, 0);
    },
    computed: {
        
        netAmountCalculate: function () {
            let totalDiscount = this.totalGeneralDiscount + this.totalExtraDiscount;

            let totalVatTax = 0;
            let result = parseFloat(this.totalCartValue + totalVatTax - totalDiscount).toFixed(2);
            this.form.grand_total = result;   
            this.form.total_amount = parseFloat(this.totalCartValue).toFixed(2);
            return parseFloat(result).toFixed(2);
        },
        totalCartValue: function () {
            return this.form.ptest_items.reduce(function (total, item) { 
                return total + item.price * item.qty;
            }, 0);
        },

        totalDiscountPercent: function () {
            return this.discount_items.reduce(function (total, item) { 
                if(item.is_checked) {
                    return total + parseFloat(item.discount_percent);
                }else{ 
                    return total + 0;
                }
            }, 0);
        },

        totalExtraDiscountPercent: function () {
            return this.discount_items.reduce(function (total, item) { 
                if(!item.name.toLowerCase().includes('general') && item.is_checked) {
                    return total + parseFloat(item.discount_percent);
                }else{ 
                    return total + 0;
                }
            }, 0);
        },

        totalGeneralDiscount: function () {
            let generalDiscountPercent = this.totalDiscountPercent - this.totalExtraDiscountPercent;
            let extraDiscountPercent = this.totalExtraDiscountPercent;
            return this.form.ptest_items.reduce(function (total, item) {
                if(item.discount >= generalDiscountPercent) {
                    return total + (((item.price * item.qty) * generalDiscountPercent) / 100);
                }else{
                    let disc_percent = item.discount - extraDiscountPercent;
                    disc_percent = disc_percent < 0 ? 0 : disc_percent;
                    return total + (((item.price * item.qty) * (disc_percent)) / 100);
                }
            }, 0);
        },

        totalExtraDiscount: function () {
            let generalDiscountPercent = this.totalDiscountPercent - this.totalExtraDiscountPercent;
            let extraDiscountPercent = this.totalExtraDiscountPercent;
            return this.form.ptest_items.reduce(function (total, item) {
                if(item.discount > generalDiscountPercent && item.discount > 0) {
                    return total + (((item.price * item.qty) * (item.discount - generalDiscountPercent)) / 100);
                }else{
                    return total + (((item.price * item.qty) * (extraDiscountPercent)) / 100);
                }
            }, 0)
        },
    }
}
</script>
<style scoped>
    .modal-content.scrollbar-width-thin {
        border: none !important;
    }

    label {
        display: inline-block;
        margin: 0px 0px 4px 2px;
        float: left;
    }

    .invalid-feedback {
        display: block;
        width: 100%;
        margin-top: 0.25rem;
        font-size: 80%;
        color: #dc3545;
        text-align: left;
    }

    #newBilling hr {
        margin-top: 0px !important;
    }

    .wpr_general_sign_title {
        width: 100%;
        display: block;
        padding: 8px 20px;
        background-color: #313A46;
        display: block;
        color: #fff;
        font-weight: 700;
        font-size: 18px;
    }

    
    /** Autocomplete */
    .autocomplete {
        position: relative;
    }

    ul.autocomplete-results {
        width: 100% !important;
        margin-top: 1px !important;
        position: absolute;
        left: 0;
        z-index: 999;
    }
    .autocomplete-results {
        padding: 0;
        margin: 0;
        border: 1px solid #eeeeee;
        /* height: 120px; */
        overflow: auto;
        width: 100%;
    }

    .autocomplete-results li{
        list-style: none;
        text-align: left;
        padding: 4px 2px;
        cursor: pointer;
    /* background: red; */
    }

    .autocomplete-results li.is-active,
    .autocomplete-results li:hover {
        background-color: #4AAE9B;
        color: white;
    }
    .autocomplete-results li:first-child {
        font-weight: 600;
        border-bottom: 1px solid #282828;
        margin-bottom: 3px;
    }
    .autocomplete-results li:first-child:hover {
        background-color: inherit;
        color: inherit;
    }

    .is-active {
        background-color: #dedede;
    }

    ul.discount_items {
        list-style: none;
        padding: 0;
    }

    ul.discount_items li {
        display: block;
        margin-right: 5px;
        clear: both;
    }

    ul.discount_items li .discount_fields .item_field input{
        margin-bottom: 5px;
    }

    /** For Invoice modal css */
    .modal-content.scrollbar-width-thin.invoice-modal {
        width: 100%;
        display: block;
        margin: auto;
    }

    .invoice-billing {
        font-family: Verdana, Geneva, Tahoma, sans-serif;
    }

    .invoice-billing #top h2{
        font-size: 18px;
    }

    .invoice-billing #top h5{
        font-size: 14px;
    }

    .invoice-billing #top p{
        font-size: 14px;
    }

    .invoice-billing #mid {
        margin-bottom: 10px;
    }

    #mid .info {
        border: 1px solid #282828;
        padding: 0 10px 5px 10px;
        border-radius: 10px;
        margin-bottom: 10px;
    }

    #mid .info table {
        width: 100%;
    }

    #mid .info table tr td{
        font-size: 14px;
    }

    #mid .info table tr td#pname {
        font-weight: 550;
        font-size: 15px;
        text-transform: uppercase;
    }

    #bot .items-info table thead {
        border: 1px solid #282828;
        font-size: 14px;
    }

    #bot .items-info table thead td{
        padding: 5px 10px;
    }

    #bot .items-info table tbody tr{
        border-bottom: 1px solid #e0e0e0;
    }
    #bot .items-info table tbody td{
        padding: 3px 10px;
        font-size: 14px;
    }

    .corporate-payment-info {
        margin-top: 10px;
    }

    .corporate-info p{
        font-size: 14px;
    }

    .payment-info {
        width: 100%;
        border: none;
    }

    .payment-info tr {
        border-bottom: 0 !important;
    }

    .payment-info tr td{
        padding: 3px 10px;
        font-size: 14px;
        border: 0 !important;
        border-top: 0 !important;
        border-bottom: 0 !important;
    }

    .status-signatures {
        margin-top: 10px;
    }

    .status-info h3 {
        font-size: 18px;
    }

    .status-info h3 span {
        padding: 5px; 
        font-size: 22px;
        border: 1px solid #282828; 
        border-radius: 0px;
    }

    .status-info span {
        font-size: 11px;
    }

    .signature-info {
        text-align: center;
    }
    .signature-info h4 {
        text-align: center;
        font-size: 16px;
        border-bottom: 2px solid #e0e0e0;
        margin-bottom: 5px;
        padding-bottom: 2px;
    }

    .signature-info span {
        font-size: 14px;
        text-align: center;
    }

    .room-info {
        margin-top: 10px;
    }

    .room-info p {
        font-size: 13px;
    }

    .room-info p span {
        padding: 5px 10px;
        font-size: 13px;
        margin-right: 5px;
        border: 1px solid #282828;
        border-radius: 0;
    }

    .legal-info {
        margin-top: 10px;
    }

    .legal-info h6 {
        text-align: center;
        font-size: 13px;
        margin-top: 0;
        margin-bottom: 7px;
    }

</style>